import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { TextV2 } from '@insights-ltd/design-library/components';
import UnescapedTrans from 'components/i18n/UnescapedTrans';
import { User } from 'types/types';
import { roleDescription } from 'utils/mappers/entityMappers';

type UserListProps = {
  users: User[];
  setUsers: (newUsers: User[]) => void;
  showRole?: boolean;
};
const UsersList = ({ users, setUsers, showRole = false }: UserListProps) => {
  const { t } = useTranslation();
  const deleteUser = (user: User) => {
    setUsers(users.filter((item) => item.id !== user.id));
  };
  return (
    <>
      {users.map((user: User) => {
        return (
          <TableRow
            key={user.id}
            data-testid={`additional-practitioner-${user.id}`}
          >
            <TableCell
              scope="row"
              sx={{
                overflowX: 'hidden',
                wordBreak: 'break-all',
              }}
            >
              <TextV2 component="span">
                <UnescapedTrans
                  i18nKey="ui.event-management.events.edit.practitioners.practitioner.bold"
                  values={{
                    fullName: user.fullName,
                    emailAddress: user.emailAddress,
                  }}
                  components={{
                    bold: <TextV2 component="span" variant="bodyBold" />,
                  }}
                />
              </TextV2>
            </TableCell>
            {showRole && (
              <TableCell>
                <TextV2 component="span">
                  {t(roleDescription(user?.role ?? 'STANDARD'))}
                </TextV2>
              </TableCell>
            )}
            <TableCell align="right">
              {users.length > 1 && (
                <Button
                  sx={(theme) => ({
                    minWidth: 'unset',
                    color: theme.palette.error.main,
                  })}
                  onClick={() => deleteUser(user)}
                >
                  <strong>
                    {t('ui.event-management.events.edit.practitioners.delete')}
                  </strong>
                </Button>
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default UsersList;
